import React, { Component } from "react";
import { formatNumber } from "../../utils/formatting";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  DateRangeFields,
  currentLang,
  saveAs,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import {
  getLogs,
  getByUid,
  getStats,
  getFilterOptions,
  getRequestLogs,
  getRequestLogByUid,
  exportLogs,
  getActionConfig,
} from "../../services/audit.service.js";

const PAGE_SIZE = 10;

// สองแท็บนี้คือ log คนละชนิดที่แยกตารางกันฝั่ง backend โดยตั้งใจ
//   audit    = 1 แถวต่อ 1 การเปลี่ยนแปลงข้อมูล (เก็บยาว ผู้ตรวจสอบดู)
//   requests = 1 แถวต่อ 1 HTTP call ของ external API (เก็บสั้น dev/ops ดู)
const TABS = {
  AUDIT: "audit",
  REQUESTS: "requests",
};

export default class AdminAuditLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: TABS.AUDIT,

      // filter ของแท็บ audit
      filter_search: "",
      filter_action: "",
      filter_channel: "",
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",

      // filter ของแท็บ request log
      filter_direction: "",
      filter_is_success: "",

      data: [],
      count: 0,
      page: 1,

      stats: null,
      options: { actions: [], entity_types: [], source_channels: [] },

      modal_detail: false,
      detail: null,
      detail_type: TABS.AUDIT,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.GetOptions();
    this.Get(1);
  }

  GetOptions = async () => {
    const result = await getFilterOptions();
    if (result?.status) {
      this.setState({ options: result.data || this.state.options });
    }
  };

  Get = async (page) => {
    const { tab } = this.state;
    loading(true);

    const result = tab === TABS.AUDIT ? await this.GetAudit(page) : await this.GetRequests(page);

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    } else {
      this.setState({ data: [], count: 0, page });
      if (result?.message) alert("", "warning", t("warning"), result.message);
    }

    loading(false);
  };

  GetAudit = async (page) => {
    const {
      filter_search,
      filter_action,
      filter_channel,
      filter_status,
      filter_start_date,
      filter_end_date,
    } = this.state;

    const filters = {
      page,
      page_size: PAGE_SIZE,
      data_search: filter_search,
      action: filter_action,
      source_channel: filter_channel,
      status: filter_status,
      start_date: filter_start_date,
      end_date: filter_end_date,
    };

    // ดึงสถิติคู่กันไปเลย จะได้ไม่ต้องรอ 2 รอบ
    const [result, statsResult] = await Promise.all([
      getLogs(filters),
      getStats({ start_date: filter_start_date, end_date: filter_end_date }),
    ]);

    if (statsResult?.status) this.setState({ stats: statsResult.data });

    return result;
  };

  GetRequests = async (page) => {
    const {
      filter_search,
      filter_direction,
      filter_is_success,
      filter_start_date,
      filter_end_date,
    } = this.state;

    return getRequestLogs({
      page,
      page_size: PAGE_SIZE,
      data_search: filter_search,
      direction: filter_direction,
      is_success: filter_is_success,
      // call ที่ token ไม่ผ่านยังไม่รู้บริษัท จึงไม่ติดมากับ company scope ปกติ
      // ขอรวมมาเสมอ เพื่อให้เห็นคำขอที่ยืนยันตัวตนไม่ผ่านในตารางเลย
      include_unscoped: "true",
      start_date: filter_start_date,
      end_date: filter_end_date,
    });
  };

  ChangeTab = (tab) => {
    this.setState(
      {
        tab,
        data: [],
        count: 0,
        page: 1,
        filter_search: "",
        filter_action: "",
        filter_channel: "",
        filter_status: "",
        filter_direction: "",
        filter_is_success: "",
      },
      () => this.Get(1)
    );
  };

  ResetFilter = () => {
    this.setState(
      {
        filter_search: "",
        filter_action: "",
        filter_channel: "",
        filter_status: "",
        filter_direction: "",
        filter_is_success: "",
        filter_start_date: "",
        filter_end_date: "",
      },
      () => this.Get(1)
    );
  };

  OpenDetail = async (uid) => {
    const { tab } = this.state;
    loading(true);

    const result = tab === TABS.AUDIT ? await getByUid(uid) : await getRequestLogByUid(uid);

    if (result?.status) {
      this.setState({ modal_detail: true, detail: result.data, detail_type: tab });
    } else {
      alert("", "warning", t("warning"), result?.message || t("audit_detail_failed"));
    }

    loading(false);
  };

  Export = async (format) => {
    const {
      filter_search,
      filter_action,
      filter_channel,
      filter_status,
      filter_start_date,
      filter_end_date,
    } = this.state;

    loading(true);
    const result = await exportLogs(
      {
        data_search: filter_search,
        action: filter_action,
        source_channel: filter_channel,
        status: filter_status,
        start_date: filter_start_date,
        end_date: filter_end_date,
      },
      format
    );

    if (result?.status && result.blob) {
      const stamp = new Date().toISOString().slice(0, 10);
      saveAs(result.blob, `audit_logs_${stamp}.${format}`);
    } else {
      alert("", "warning", t("warning"), result?.message || t("audit_export_failed"));
    }

    loading(false);
  };

  /**
   * แปลง Date จาก DateRangePicker เป็น YYYY-MM-DD ตาม local time ให้ตรงกับที่ backend รับ
   * (ไม่ใช้ toISOString เพราะจะเลื่อนวันตาม timezone)
   * @param {Date|null} date
   * @returns {string}
   */
  ToDateOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  /**
   * นับจำนวนของ action ที่ต้องการจากผลสรุป
   * @param {string} action
   * @returns {number}
   */
  StatOf = (action) => {
    const row = (this.state.stats?.by_action || []).find((item) => item.action === action);
    return row?.total || 0;
  };

  renderStats() {
    const { stats } = this.state;
    if (!stats) return null;

    const cards = [
      { label: t("audit_total"), value: stats.total || 0, icon: "", color: "text-primary" },
      { label: t("audit_created"), value: this.StatOf("CREATE"), icon: "", color: "text-success" },
      { label: t("audit_updated"), value: this.StatOf("UPDATE"), icon: "", color: "text-warning" },
      { label: t("audit_deleted"), value: this.StatOf("DELETE"), icon: "", color: "text-danger" },
    ];

    return (
      <div className="row g-3 mb-4">
        {cards.map((card, idx) => (
          <div className="col-6 col-lg-3" key={idx}>
            <div className="bg-white rounded-4 shadow-sm p-3 h-100 d-flex align-items-center gap-3">
              <span className={`icon text-20 ${card.color}`}>{card.icon}</span>
              <div>
                <div className="text-secondary text-12">{card.label}</div>
                <div className="fw-bold text-20 text-dark">{card.value.toLocaleString()}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderAuditRows() {
    const { data } = this.state;

    if (!data.length) {
      return (
        <tr>
          <td colSpan="6" className="text-center text-secondary py-5">
            {t("no_data")}
          </td>
        </tr>
      );
    }

    return data.map((item, idx) => {
      const action = getActionConfig(item.action);

      return (
        <tr key={idx} className="border-bottom border-light bg-white">
          <td>
            <div className="text-secondary text-14">{item.created_at || "-"}</div>
          </td>
          <td>
            <span className={`text-12 fw-bold px-2 py-1 rounded-pill ${action.className}`}>
              {action.label}
            </span>
          </td>
          <td>
            <div className="text-dark text-14">{item.entity_name || "-"}</div>
            <div className="text-secondary text-12">{item.entity_type || "-"}</div>
          </td>
          <td>
            <div className="text-dark text-14">{item.actor_name || "-"}</div>
            <div className="text-secondary text-12">
              {item.actor_type === "external_api"
                ? item.external_token_name || t("audit_external_api")
                : item.actor_role || "-"}
            </div>
          </td>
          <td className="text-center">
            {/* เน้นรายการที่มาจากแอปช่างให้เห็นชัด จะได้ไล่ดูได้โดยไม่ต้องกรองก่อน
                ใช้ bg-primary-light - .bg-primary ของโปรเจกต์เป็นสีทึบ !important ใส่คู่ text-primary แล้วมองไม่เห็นตัวอักษร */}
            {item.source_channel === "mobile" ? (
              <span className="text-12 fw-bold px-2 py-1 rounded-pill text-primary bg-primary-light">mobile</span>
            ) : (
              <span className="text-secondary text-12">{item.source_channel || "-"}</span>
            )}
          </td>
          <td className="text-center">
            <div className="d-flex align-items-center gap-2 justify-content-center">
              <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.OpenDetail(item.uid)} />
            </div>
          </td>
        </tr>
      );
    });
  }

  renderRequestRows() {
    const { data } = this.state;

    if (!data.length) {
      return (
        <tr>
          <td colSpan="7" className="text-center text-secondary py-5">
            {t("no_data")}
          </td>
        </tr>
      );
    }

    return data.map((item, idx) => (
      <tr key={idx} className="border-bottom border-light bg-white">
        <td>
          <div className="text-secondary text-14">{item.created_at || "-"}</div>
        </td>
        <td>
          <span
            className={`text-12 fw-bold px-2 py-1 rounded-pill ${
              item.direction === "outbound"
                ? "text-info bg-info-light"
                : "text-primary bg-primary-light"
            }`}
          >
            {item.direction === "outbound" ? t("audit_outbound") : t("audit_inbound")}
          </span>
        </td>
        <td>
          <div className="text-dark text-14">{item.method}</div>
          <div className="text-secondary text-12 text-break">
            {item.route_pattern || item.url}
          </div>
        </td>
        <td className="text-center">
          <span
            className={`text-12 fw-bold px-2 py-1 rounded-pill ${
              item.is_success ? "text-success bg-success-light" : "text-danger bg-danger-light"
            }`}
          >
            {item.response_status || "-"}
          </span>
        </td>
        <td className="text-center">
          <span className="text-secondary text-12">
            {item.duration_ms !== null && item.duration_ms !== undefined
              ? `${item.duration_ms} ms`
              : "-"}
          </span>
        </td>
        <td>
          <div className="text-secondary text-12">
            {item.external_token_name || item.integration_name || "-"}
          </div>
        </td>
        <td className="text-center">
          <div className="d-flex align-items-center gap-2 justify-content-center">
            <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.OpenDetail(item.uid)} />
          </div>
        </td>
      </tr>
    ));
  }

  /**
   * แสดง JSON ก้อนหนึ่งในกล่อง scroll ได้ ไม่ให้ล้นหน้าจอ
   */
  renderJsonBlock(title, value) {
    return (
      <div className="col-12 col-lg-6">
        <div className="text-14 fw-bold text-dark mb-2">{title}</div>
        <pre
          className="bg-light rounded-3 p-3 text-12 mb-0"
          style={{ maxHeight: "320px", overflow: "auto", whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {value ? JSON.stringify(value, null, 2) : "-"}
        </pre>
      </div>
    );
  }

  renderAuditDetail(detail) {
    const changed = detail.changed_fields || [];

    return (
      <div className="row g-4">
        <div className="col-12">
          <div className="row g-3 text-14">
            {[
              [t("audit_timestamp"), detail.created_at],
              [t("audit_action"), detail.action],
              [t("audit_entity"), `${detail.entity_type || "-"} / ${detail.entity_name || "-"}`],
              [t("audit_entity_id"), detail.entity_id],
              [t("audit_actor"), detail.actor_name],
              [t("audit_actor_role"), detail.actor_role],
              [t("audit_actor_type"), detail.actor_type],
              [t("audit_channel"), detail.source_channel],
              [t("audit_ip"), detail.ip_address],
              [t("audit_endpoint"), `${detail.http_method || ""} ${detail.endpoint || "-"}`],
              [t("audit_request_id"), detail.request_id],
              [t("audit_status"), detail.status],
            ].map(([label, value], idx) => (
              <div className="col-md-6" key={idx}>
                <div className="text-secondary text-12">{label}</div>
                <div className="text-dark text-break">{value || "-"}</div>
              </div>
            ))}
          </div>
        </div>

        {detail.reason ? (
          <div className="col-12">
            <div className="text-secondary text-12">{t("audit_reason")}</div>
            <div className="text-dark">{detail.reason}</div>
          </div>
        ) : null}

        {detail.error_message ? (
          <div className="col-12">
            <div className="text-secondary text-12">{t("audit_error")}</div>
            <div className="text-danger text-break">{detail.error_message}</div>
          </div>
        ) : null}

        {changed.length ? (
          <div className="col-12">
            <div className="text-secondary text-12 mb-2">{t("audit_changed_fields")}</div>
            <div className="d-flex flex-wrap gap-2">
              {changed.map((field, idx) => (
                <span
                  key={idx}
                  className="text-12 text-warning bg-warning-light fw-bold px-2 py-1 rounded-pill"
                >
                  {field}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        {this.renderJsonBlock(t("audit_old_values"), detail.old_values)}
        {this.renderJsonBlock(t("audit_new_values"), detail.new_values)}
      </div>
    );
  }

  renderRequestDetail(detail) {
    return (
      <div className="row g-4">
        <div className="col-12">
          <div className="row g-3 text-14">
            {[
              [t("audit_timestamp"), detail.created_at],
              [t("audit_direction"), detail.direction],
              [t("audit_endpoint"), `${detail.method || ""} ${detail.url || "-"}`],
              [t("audit_http_status"), detail.response_status],
              [t("audit_duration"), detail.duration_ms ? `${detail.duration_ms} ms` : "-"],
              [t("audit_integration"), detail.integration_name],
              [t("audit_token"), detail.external_token_name],
              [t("audit_ip"), detail.ip_address],
              [t("audit_request_id"), detail.request_id],
            ].map(([label, value], idx) => (
              <div className="col-md-6" key={idx}>
                <div className="text-secondary text-12">{label}</div>
                <div className="text-dark text-break">{value || "-"}</div>
              </div>
            ))}
          </div>
        </div>

        {detail.error_message ? (
          <div className="col-12">
            <div className="text-secondary text-12">{t("audit_error")}</div>
            <div className="text-danger text-break">{detail.error_message}</div>
          </div>
        ) : null}

        {detail.request_truncated || detail.response_truncated ? (
          <div className="col-12">
            <div className="text-warning text-12">{t("audit_truncated_note")}</div>
          </div>
        ) : null}

        {this.renderJsonBlock(t("audit_request_headers"), detail.request_headers)}
        {this.renderJsonBlock(t("audit_request_query"), detail.request_query)}
        {this.renderJsonBlock(t("audit_request_body"), detail.request_body)}
        {this.renderJsonBlock(t("audit_response_body"), detail.response_body)}
      </div>
    );
  }

  render() {
    const {
      tab,
      data,
      count,
      page,
      options,
      filter_search,
      filter_action,
      filter_channel,
      filter_status,
      filter_direction,
      filter_is_success,
      filter_start_date,
      filter_end_date,
      modal_detail,
      detail,
      detail_type,
    } = this.state;

    const isAudit = tab === TABS.AUDIT;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("audit_logs")}</h3>
              <div className="text-secondary text-14">{t("audit_logs_desc")}</div>
            </div>
            {isAudit ? (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 d-flex align-items-center"
                  onClick={() => this.Export("csv")}
                >
                  <span className="icon me-2">{""}</span> CSV
                </button>
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 d-flex align-items-center"
                  onClick={() => this.Export("xlsx")}
                >
                  <span className="icon me-2">{""}</span> Excel
                </button>
              </div>
            ) : null}
          </div>

          {isAudit ? this.renderStats() : null}

          {/* Tabs + filters */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex gap-2 mb-4 border-bottom">
              <button
                className={`btn border-0 rounded-0 px-3 pb-2 fw-bold ${
                  isAudit ? "text-primary border-bottom border-2 border-primary" : "text-secondary"
                }`}
                onClick={() => this.ChangeTab(TABS.AUDIT)}
              >
                {t("audit_tab_changes")}
              </button>
              <button
                className={`btn border-0 rounded-0 px-3 pb-2 fw-bold ${
                  !isAudit ? "text-primary border-bottom border-2 border-primary" : "text-secondary"
                }`}
                onClick={() => this.ChangeTab(TABS.REQUESTS)}
              >
                {t("audit_tab_requests")}
              </button>
            </div>

            <div className="row g-3 align-items-end">
              {/* แท็บ request: ค้นหา 3 + select 2+2 + ช่วงวันที่ 5 = 12 (วันที่เริ่ม/สิ้นสุดอยู่บรรทัดเดียวกัน)
                  แท็บ audit: ค้นหา 2 + select 2x3 + ช่วงวันที่ 4 = 12 · ปุ่มขึ้นแถวใหม่ชิดขวา */}
              <div className={isAudit ? "col-md-2" : "col-md-3"}>
                <label className="form-label text-12 text-secondary mb-1">{t("search")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={isAudit ? t("audit_search_placeholder") : t("audit_search_request_placeholder")}
                  value={filter_search}
                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>

              {isAudit ? (
                <>
                  <div className="col-md-2">
                    <label className="form-label text-12 text-secondary mb-1">{t("audit_action")}</label>
                    <select
                      className="form-select"
                      value={filter_action}
                      onChange={(e) => this.setState({ filter_action: e.target.value }, () => this.Get(1))}
                    >
                      <option value="">{t("all")}</option>
                      {(options.actions || []).map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label text-12 text-secondary mb-1">{t("audit_channel")}</label>
                    <select
                      className="form-select"
                      value={filter_channel}
                      onChange={(e) => this.setState({ filter_channel: e.target.value }, () => this.Get(1))}
                    >
                      <option value="">{t("all")}</option>
                      {(options.source_channels || []).map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label text-12 text-secondary mb-1">{t("status")}</label>
                    <select
                      className="form-select"
                      value={filter_status}
                      onChange={(e) => this.setState({ filter_status: e.target.value }, () => this.Get(1))}
                    >
                      <option value="">{t("all")}</option>
                      <option value="success">{t("audit_success")}</option>
                      <option value="failed">{t("audit_failed")}</option>
                    </select>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-md-2">
                    <label className="form-label text-12 text-secondary mb-1">{t("audit_direction")}</label>
                    <select
                      className="form-select"
                      value={filter_direction}
                      onChange={(e) => this.setState({ filter_direction: e.target.value }, () => this.Get(1))}
                    >
                      <option value="">{t("all")}</option>
                      <option value="inbound">{t("audit_inbound")}</option>
                      <option value="outbound">{t("audit_outbound")}</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label text-12 text-secondary mb-1">{t("status")}</label>
                    <select
                      className="form-select"
                      value={filter_is_success}
                      onChange={(e) => this.setState({ filter_is_success: e.target.value }, () => this.Get(1))}
                    >
                      <option value="">{t("all")}</option>
                      <option value="true">{t("audit_success")}</option>
                      <option value="false">{t("audit_failed")}</option>
                    </select>
                  </div>
                </>
              )}

              <div className={isAudit ? "col-md-4" : "col-md-5"}>
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type={currentLang()}
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_start_date}
                    endValue={filter_end_date}
                    onChange={({ start, end }) =>
                      this.setState(
                        { filter_start_date: start, filter_end_date: end },
                        () => end && this.Get(1)
                      )
                    }
                  />
                </div>
              </div>
              <div className="col-12 d-flex gap-2 justify-content-end">
                <button className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={() => this.Get(1)}>
                  {t("search")}
                </button>
                <button className="btn btn-white border px-3 py-2 rounded-3" onClick={this.ResetFilter}>
                  <span className="icon">{""}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1100px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    {isAudit ? (
                      <>
                        <th className="py-3 border-0 wpx-180">{t("audit_timestamp")}</th>
                        <th className="py-3 border-0 wpx-120">{t("audit_action")}</th>
                        <th className="py-3 border-0">{t("audit_entity")}</th>
                        <th className="py-3 border-0 wpx-200">{t("audit_actor")}</th>
                        <th className="py-3 border-0 text-center wpx-120">{t("audit_channel")}</th>
                        <th className="py-3 border-0 text-center wpx-80">{t("actions")}</th>
                      </>
                    ) : (
                      <>
                        <th className="py-3 border-0 wpx-180">{t("audit_timestamp")}</th>
                        <th className="py-3 border-0 wpx-120">{t("audit_direction")}</th>
                        <th className="py-3 border-0">{t("audit_endpoint")}</th>
                        <th className="py-3 border-0 text-center wpx-100">{t("audit_http_status")}</th>
                        <th className="py-3 border-0 text-center wpx-100">{t("audit_duration")}</th>
                        <th className="py-3 border-0 wpx-180">{t("audit_token")}</th>
                        <th className="py-3 border-0 text-center wpx-80">{t("actions")}</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>{isAudit ? this.renderAuditRows() : this.renderRequestRows()}</tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
            <div>
              {t("showing")} {data.length ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-
              {formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / PAGE_SIZE) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, nextPage) => this.Get(nextPage)}
            />
          </div>
        </div>

        {/* MODAL: DETAIL */}
        <Modal
          show={modal_detail}
          onHide={() => this.setState({ modal_detail: false, detail: null })}
          centered
          size="xl"
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">
              {detail_type === TABS.AUDIT ? t("audit_detail_title") : t("audit_request_detail_title")}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            {detail
              ? detail_type === TABS.AUDIT
                ? this.renderAuditDetail(detail)
                : this.renderRequestDetail(detail)
              : null}
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_detail: false, detail: null })}
            >
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
